import Backbone	from 'backbone'
import * as d3 from 'd3-selection'
import { SHAPE_TYPE } from '../shape-type'
import _ from 'lodash'

// All valid `symbol` values from impact-shape
const SHAPES = _.values(SHAPE_TYPE)

/**
 * View that lists all possible shapes and allows the user to select one
 */
const ShapePicker = Backbone.View.extend({
	className: 'shape-picker bootslide-container-row',

	tagName: 'ul',

	/**
	 * @param {Function} [opt.getSelectedShape] - function that returns the
	 * shape that should appear selected. Note that this is called both on
	 * initial render and any time the user selects a shape icon. If no
	 * function is provided, no shape will be pre-selected
	 *
	 * @param {Function} [opt.onSelectShape] - function that is called when the
	 * the user selects a shape icon. The selected shape is passed as the first
	 * argument
	 */
	initialize (opt = {}) {
		this.options = opt
	},

	render () {
		let iconData = SHAPES.map(shape => {
			return {
				id: shape,
				selected: shape === this.options?.getSelectedShape?.()
			}
		})

		// Note: using d3 for this, because building (and especially updating)
		// SVGs is buggy with jQuery
		const shapes = d3.select(this.el).selectAll('.shape-item')
			.data(iconData)

		// Initial creation of the shape icon containers. Using <li> elements
		// because that seems to work with existing styles
		const shapesEnter = shapes.enter()
			.append('li')
			.classed('shape-item', true)
			.on('click', (e, d) => this.selectShape(d.id))

		// Create icon SVGs in the <li> elements
		shapesEnter.append('svg')
			.append('use')
			.attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')

		// Update <li> and SVGs with selection status (which can change the
		// icon ID)
		shapes.merge(shapesEnter)
			.classed('selected', d => d.selected)
			.select('svg')
			.classed('is-duotone', d => !d.selected)
			.select('use')
			.attr('xlink:href', d => `#icon-wob-${d.id}-gradient-filled`)

		return this
	},

	selectShape (shape) {
		this.options?.onSelectShape?.(shape)
		this.render()
	}
})

export default ShapePicker
export { SHAPES }

ShapePicker.__filename__ = 'dashboards/widgets/shape/config/shape-picker.js'
